import React from 'react';
import PropTypes from 'prop-types';


const Err404 = ({ location }) => (
  <div>
    <h3>
      Sorry but this page does not exist

      <code>{location.pathname}</code>
    </h3>
    <p>404</p>
  </div>
);

Err404.propTypes = {
  location: PropTypes.object,
};

export default Err404


// WEBPACK FOOTER //
// ./src/app/containers/Error/404.js